import { Value } from "formula-engine";
import Formula from "~/models/formula";

/**
 * Lookup function used by the `FormulaEvaluator` Parser
 */
export default {
  methods: {
    getValueFromReferenceName(referenceId: string): Value | null {
      const idComponents = Formula.parseDynamicId(referenceId)
      if (idComponents.dynamicReferenceType) {
        // make more restrictive if needed
        return Value.number(1);
      }

      const name: string = Formula.buildDynamicId({prefix: idComponents.prefix, id: idComponents.id})

      const lookupInForm = form => {
        if (form.getFormElements.some(formElement => Formula.buildDynamicId({
          prefix: idComponents.prefix,
          id: Formula.clientIdToFormulaId(formElement.client_id),
        }) === name)) {
          return Value.number(1);
        } else {
          return null;
        }
      }
      const lookupInObjectModel = om => {
        if (om.objectModelPropertiesArray.some(prop => Formula.buildDynamicId({
          prefix: idComponents.prefix,
          id: Formula.clientIdToFormulaId(prop.client_id),
        }) === name)) {
          return Value.number(1);
        } else {
          return null;
        }
      }
      let forms = [];
      if (this.forms) forms = forms.concat(this.forms)
      if (this.form) forms = forms.concat([this.form])

      let objectModels = [];
      if (this.objectModels) objectModels = objectModels.concat(this.objectModels)
      if (this.objectModel) objectModels = objectModels.concat([this.objectModel])

      if (this.dynamicOptions) {
        for (const o of this.dynamicOptions) {
          const handler = o.props['fieldsHandler'];
          if (handler.form) forms.push(handler.form);
          if (handler.objectModel) objectModels.push(handler.objectModel);
        }
      }

      for (const f of forms) {
        const res = lookupInForm(f);
        if (res) {
          return res;
        }
      }

      for (const om of objectModels) {
        const res = lookupInObjectModel(om);
        if (res) {
          return res;
        }
      }

      return null;
    },
  }
}
